// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"72":"0b7557ff","216":"93d7a52b","284":"59c1c147","573":"b7f3b263","672":"9cd827dc","807":"4db950f0"}[chunkId] + ".chunk.js";
};